import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonLiveNotificationsRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/live-notifications/:conversationId` — the address the embedded app
 * links a live notification to. It forwards to the notification's own URL once the rollout flag is
 * on, and renders the embedded app in place while it is off.
 */
function JourneysPersonLiveNotificationRoute() {
  const { personId, conversationId } = Route.useParams();

  return <JourneysPersonLiveNotificationsRoute personId={personId} conversationId={conversationId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/live-notifications/$conversationId',
)({
  component: JourneysPersonLiveNotificationRoute,
});
